<section class="existing-backup-contact-container">
  <div>
    <h1 class="existing-backup-contact-header">
      {{ "REGISTER.EXISTING_BACKUP_CONTACT.TITLE" | translate }}
    </h1>

    <p class="existing-backup-contact-explanation">
      {{ "REGISTER.EXISTING_BACKUP_CONTACT.DESCRIPTION" | translate }}
    </p>
  </div>

  <form
    (ngSubmit)="handleSubmit()"
    [formGroup]="existingBackupContactForm"
    class="existing-backup-contact-form"
    id="existing-backup-contact-form"
  >
    @if (state().hasServerSideError) {
      <c-banner
        class="existing-backup-contact-banner-error"
        iconPositionX="top"
        [style]="
          state().errorType === 'email-already-used' ? 'warning' : 'error'
        "
        [message]="
          state().errorType === 'gateway-timeout'
            ? ('REGISTER.GENERIC_FORM.ERRORS.GENERIC-GATEWAY-TIMEOUT'
              | translate)
            : state().errorType === 'email-already-used'
              ? ('REGISTER.BACKUP_CONTACT.ERRORS.EMAIL-ALREADY-USE' | translate)
              : ''
        "
      >
        @if (state().errorType === "generic-error") {
          <div class="existing-backup-contact-banner-message">
            <span>
              {{
                "REGISTER.GENERIC_FORM.ERRORS.GENERIC-SERVER-PART-1" | translate
              }}
            </span>
            <span>
              {{
                "REGISTER.GENERIC_FORM.ERRORS.GENERIC-SERVER-PART-2" | translate
              }}
            </span>
            <a
              class="existing-backup-contact-banner-link"
              href="mailto:support@cariloop.com"
            >
              {{
                "REGISTER.GENERIC_FORM.ERRORS.GENERIC-SERVER-PART-3" | translate
              }}
            </a>
          </div>
        }
      </c-banner>
    }

    <div
      class="existing-backup-contact-alternate-contact-method-container"
      formGroupName="alternateContactMethodGroup"
    >
      <c-input-text
        [disabled]="state().isSubmitting"
        formControlName="phoneNumber"
        label="{{ 'REGISTER.BACKUP_CONTACT.INPUT_PHONE' | translate }}"
        type="text"
        placeholder="{{
          'REGISTER.EXISTING_BACKUP_CONTACT.PHONE_PLACEHOLDER' | translate
        }}"
      >
        @if (
          existingBackupContactForm.get(
            "alternateContactMethodGroup.phoneNumber"
          ).errors?.required !== undefined
        ) {
          {{
            "REGISTER.EXISTING_BACKUP_CONTACT.REQUIRED_PHONE_NUMBER" | translate
          }}
        }
        @if (
          existingBackupContactForm.get(
            "alternateContactMethodGroup.phoneNumber"
          ).errors?.pattern !== undefined
        ) {
          {{
            "REGISTER.EXISTING_BACKUP_CONTACT.INVALID_PHONE_NUMBER" | translate
          }}
        }
      </c-input-text>
    </div>
    <div class="checkbox-container">
      <label class="checkbox">
        <input type="checkbox" formControlName="consentMarketing" />
        <span>{{ "REGISTER.BACKUP_CONTACT.CONSENT" | translate }}</span>
      </label>
    </div>
  </form>

  @if (state().isSubmitting) {
    <mat-spinner diameter="40" />
  } @else {
    <button
      cari-button
      class="existing-backup-contact-form-button brand-submit-btn"
      form="existing-backup-contact-form"
      type="submit"
      data-shape="squared"
      data-type="neutral"
      data-style="fill"
      data-size="x-large"
    >
      {{ "REGISTER.EXISTING_BACKUP_CONTACT.CONTINUE" | translate }}
    </button>
  }

  <div class="terms-container">
    <p>
      {{ "REGISTER.BACKUP_CONTACT.PRIVACY_DESCRIPTION" | translate }}
      <a
        aria-label="Privacy Policy"
        href="https://www.cariloop.com/privacy-policy/"
        target="_blank"
        >{{ "REGISTER.BACKUP_CONTACT.PRIVACY_POLICY_LINK" | translate }}</a
      >
      {{ "REGISTER.BACKUP_CONTACT.AND" | translate }}
      <a
        aria-label="Terms of service"
        href="https://www.cariloop.com/terms-of-service/"
        target="_blank"
        >{{ "REGISTER.BACKUP_CONTACT.TERMS_OF_SERVICE_LINK" | translate }}</a
      >.
    </p>
  </div>
</section>
